export const USER_SUB_REGION_PERMISSIONS = {
  ADD: 'ADD_USER_SUB_REGION',
} as const;

export type UserSubRegionPermissions = typeof USER_SUB_REGION_PERMISSIONS[keyof typeof USER_SUB_REGION_PERMISSIONS];
